// @ts-nocheck
/* eslint-disable */
import SceneMarkerBubble, { isRectIntersection } from "./bubble";

export default class SceneMarkerBubblePubt extends SceneMarkerBubble {
	/**
	 * Vytvoreni markeru bubliny.
	 *
	 * @param  {SceneCoords} coords Souradnice
	 * @param  {Number|String} [id] Volitelne ID
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords, id, opts) {
		let _opts = {
			angle: 0,
			arrowLength: 32,
			arrowCenter: [16,16],
			bubbleHeight: 32,
			bubbleWidth: 110
		};

		for (let p in opts) { _opts[p] = opts[p]; }

		super(scene, itemId, coords, id, _opts);

		this._BBox = null;
	}

	set arrowAngle(angle) {
		this._options.angle = angle;

		const newPosition = this._onChange(this._scene.featureEvent("markerBubbleSetArrowAngle", true, true), arguments);

		this._BBox = null;

		if (newPosition) {
			this._BBox = [
				[newPosition.left, newPosition.top],
				[newPosition.right, newPosition.bottom]
			];
		}
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerBubblePubt",
			type: "marker"
		};
	}

	get BBox() {
		if (!this._BBox && this._options.elm) {
			const clientRect = this._options.elm.getBoundingClientRect();

			this._BBox = [
				[clientRect.left, clientRect.top],
				[clientRect.right, clientRect.bottom]
			];

			//this._options.bubbleHeight =
		}

		return this._BBox;
	}

	/**
	 * pokus o vyreseni kolizi, ke kterym dochazi mezi markerem a geometrii routy
	 * @private
	 * @param  {Array} geomPixels pole poli pixelovych souradnic geometrii
	 * @param  {Integer} toAngle do jakeho uhlu se ma pocitat
	 * @param  {Integer} fromAngle od jakeho uhlu se ma pocitat
	 * @return {Boolean}        zdali doslo k repozicovani markeru
	 */
	resolveColision(geomPixels, toAngle = 359, fromAngle = 0) {
		let maxAngle = 359;
		let angleSteps = 40;
		let resolve = false;
		let zoomColisions = [];

		if (!(geomPixels[0] instanceof Array)) {
			geomPixels = [geomPixels];
		}

		if (this.arrowAngle < fromAngle) {
			this.arrowAngle = fromAngle;
		}

		if (this.arrowAngle > toAngle) {
			this.arrowAngle = toAngle;
		}

		let inRect = (box, point) => {
			return point.x > Math.min(box[0][0], box[1][0])-5 && point.x < Math.max(box[0][0], box[1][0])+5 && point.y > Math.min(box[0][1], box[1][1])-5 && point.y < Math.max(box[0][1], box[1][1])+5;
		}

		let colision = maxColision => {
			let bbox = this.BBox;
			let colision = 0;

			if (!maxColision) {
				maxColision = Infinity;
			}

			geomPixels.forEach(pixels => {
				for (let i = 0; i < pixels.length; i++) {
					let px = pixels[i];

					if (inRect(bbox, px)) {
						colision++;
						if (colision > maxColision) {
							break;
						}
					} else if (i > 0 && isRectIntersection(bbox, px, pixels[i-1])){
						colision++;
						if (colision > maxColision) {
							break;
						}
					}
				}
			});

			return colision;
		}

		if (colision()) {
			let indexWithMinColision = 0;
			const angleStep = (toAngle - fromAngle) / angleSteps;

			for (let step = fromAngle, index = 0; step <= toAngle; step += angleStep, index++) {
				this.arrowAngle = Math.round(step);
				let c = colision(zoomColisions[indexWithMinColision] ? zoomColisions[indexWithMinColision].colisions : Infinity);

				if (!c) {
					resolve = true;
					break;
				}

				zoomColisions.push({
					colisions: c,
					angle: step
				});

				if (zoomColisions[indexWithMinColision].colisions > c.colisions) {
					min = index;
				}
			}

			if (!resolve && zoomColisions.length) {
				let sort = zoomColisions.slice();
				sort.sort((a,b) => {
					return a.colisions-b.colisions;
				});

				this.arrowAngle = Math.round(sort[0].angle);
			}
		}
		else {
			resolve = true;
		}

		return resolve;
	}

	setOptions(options) {
		this._BBox = null;

		super.setOptions(options);
	}
}
